const CreateBrand = {
  EN: {
    Brand: {
      title: 'Brand',
      name: 'Brand name',
    },
    Ownerinformation: {
      title: 'Owner Information',
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone Number',
    },
    Bussinessinformation: {
      title: 'Business Information',
      type: 'Business Type',
      vat: 'VAT Registration',
    },
    Bussinessdescription: {
      title: 'Business Description',
      name: 'Business Name',
      address: 'Address',
      address1: 'Address Line 1',
      address2: 'Address Line 2',
      subdistrict: 'Subdistrict',
      district: 'District',
      province: 'Province',
      postalcode: 'Postal Code',
      main_address: 'Main Address',
      bill_address: 'Billing Address',
      ship_address: 'Shipping Address',
      taxNo: 'Tax Number',
      office: 'Office/Branch',
      office_Head: 'Head Office',
      office_branch: 'Branch',
    },
    Contact: {
      title: 'Contact',
      office_No: 'Office Number',
      phone_No: 'Phone Number',
      fax_No: 'Fax Number',
    },
    NamePrefix: {
      mr: 'Mr.',
      ms: 'Ms.',
      mrs: 'Mrs.',
    },
    BussinessType: {
      person: 'Sole Proprietorship',
      partner: 'Partnership',
      company: 'Private Company',
      public: 'Public Company',
    },
    VAT: {
      done: 'Registered',
      notyet: 'Not Registered',
    },
  },
  TH: {
    Brand: {
      title: 'แบรนด์',
      name: 'ชื่อแบรนด์',
    },
    Ownerinformation: {
      title: 'ข้อมูลเจ้าของ',
      name: 'ชื่อเต็ม',
      email: 'อีเมล',
      phone: 'หมายเลขโทรศัพท์',
    },
    Bussinessinformation: {
      title: 'ข้อมูลธุรกิจ',
      type: 'ประเภทธุรกิจ',
      vat: 'การจดทะเบียนภาษีมูลค่าเพิ่ม',
    },
    Bussinessdescription: {
      title: 'รายละเอียดธุรกิจ',
      name: 'ชื่อธุรกิจ',
      address: 'ที่อยู่',
      address1: 'ที่อยู่ที่ 1',
      address2: 'ที่อยู่ที่ 2',
      subdistrict: 'ตำบล',
      district: 'อำเภอ',
      province: 'จังหวัด',
      postalcode: 'รหัสไปรษณีย์',
      main_address: 'ที่อยู่หลัก',
      bill_address: 'ที่อยู่สำหรับวางบิล',
      ship_address: 'ที่อยู่สำหรับจัดส่ง',
      taxNo: 'เลขประจำตัวผู้เสียภาษี',
      office: 'สำนักงาน/สาขา',
      office_Head: 'สำนักงานใหญ่',
      office_branch: 'สาขา',
    },
    Contact: {
      title: 'ติดต่อ',
      office_No: 'หมายเลขสำนักงาน',
      phone_No: 'หมายเลขโทรศัพท์',
      fax_No: 'หมายเลขแฟกซ์',
    },
    NamePrefix: {
      mr: 'นาย',
      ms: 'นางสาว',
      mrs: 'นาง',
    },
    BussinessType: {
      person: 'บริษัทเจ้าของคนเดียว',
      partner: 'ห้างหุ้นส่วน',
      company: 'บริษัทจำกัด',
      public: 'บริษัทจำกัดมหาชน',
    },
    VAT: {
      done: 'ได้จดทะเบียน',
      notyet: 'ยังไม่ได้จดทะเบียน',
    },
  },
};

export default CreateBrand;
